import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  EventConfigRequestData,
  EventConfigResponseData,
} from './event-config.data-model';

@Injectable({
  providedIn: 'root',
})
export class EventConfigDataService {
  private readonly _http = inject(HttpClient);

  getEventConfig(
    requestData: EventConfigRequestData
  ): Observable<EventConfigResponseData> {
    const headers = new HttpHeaders({
      'x-api-key': environment.X_API_KEY,
    });

    return this._http.post<EventConfigResponseData>(
      environment.apiUrl + '/r1/getEventConfig',
      requestData,
      { headers }
    );
  }
}
